import styled from 'styled-components';

export const Footer = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #bfbabb;
`;

export const Column = styled.div`
  display: flex;
  justify-content: end;
  padding: 1rem;
`;
